import type { Schema } from '@biteinc/common';

export const menuItemAffinityRunSchema: Schema.Model = {
  displayName: 'menu item affinity run',
  type: 'object',
  fields: {
    name: {
      type: 'shortString',
      isReadOnly: true,
    },
    status: {
      type: 'shortString',
      isReadOnly: true,
    },
    source: {
      type: 'shortString',
      isReadOnly: true,
    },
    generatedAt: {
      type: 'timestamp',
      isReadOnly: true,
    },
    uploadedRuleCount: {
      type: 'int',
      isReadOnly: true,
    },
    s3Key: {
      type: 'shortString',
      isReadOnly: true,
    },
  },
};
